export default "__VITE_ASSET__BKGJid75__"